import React, { useContext } from 'react';
import {
  Card,
  CardHeaderNumber,
  CardContentLine,
} from './MetricsCard';
import { useHistory } from 'react-router';
import { AppContext } from '../context/AppContext';
import colors from '../styles/colors';
import { SU_DashboardFilteresTypes, DashboardFiltersSubTypes } from '../util/CustomerFilterEnum';
import { getFilteredSuperadminContacts } from '../util/customersUtil';

export default function TotalCouponsActivatedCard({ metrics,timeRange }) {

  const { setApp } = useContext(AppContext);
  const history = useHistory();
  const isNewClickable = metrics?.totalCouponsActivatedNew > 0;
  const isReturningClickable = metrics?.totalCouponsActivatedRepeat > 0;
  const isReferrersClickable = metrics?.totalCouponsActivatedAffiliate > 0;
  const onClickHandler = (subType) => getFilteredSuperadminContacts(setApp, history, {
    type: SU_DashboardFilteresTypes.DiscountsActivated,
    subType,
    ...timeRange,
  });


  return (
    <Card title="Discounts Activated">
      <CardHeaderNumber>{metrics.totalCouponsActivated.toLocaleString()}</CardHeaderNumber>
      <CardContentLine
        left="New Customers"
        right={metrics.totalCouponsActivatedNew.toLocaleString()}
        color={isNewClickable ? colors.seaGreen : colors.grey2}
        onClick={isNewClickable ? () => onClickHandler(DashboardFiltersSubTypes.New) : null}
      />
      <CardContentLine
        left="Returning Customers"
        right={metrics.totalCouponsActivatedRepeat.toLocaleString()}
        color={isReturningClickable ? colors.seaGreen : colors.grey2}
        onClick={isReturningClickable ? () => onClickHandler(DashboardFiltersSubTypes.Returning) : null}
      />
      <CardContentLine
        left="Referrers"
        right={metrics.totalCouponsActivatedAffiliate.toLocaleString()}
        color={isReferrersClickable ? colors.seaGreen : colors.grey2}
        onClick={isReferrersClickable ? () => onClickHandler(DashboardFiltersSubTypes.Referrers) : null}
      />
    </Card>
  );
}
